/*
  ============================================================
  PHOTOGRAPHY PREMIUM
  Site configuration
  ============================================================

  Asiakaskohtaiset asetukset pidetään täällä.

  Template-komponentteihin ei lähtökohtaisesti kovakoodata:
  - nimeä
  - logoa
  - kieliä
  - hero-mediaa
  - yhteystietoja
  - some-linkkejä
*/

export const siteConfig = {
  brand: {
    name: "Photography Studio",
    shortName: "Photography",
    tagline: "Stories worth remembering.",
    location: "Finland",

    /*
      Jos logo on tyhjä, käytetään tekstilogoa.
    */
    logo: "",
  },

  /*
    ==========================================================
    PRODUCT / PREMIUM DEMO
    ==========================================================

    Tämä blokki kuuluu myytävän Photography Premium -demon
    esittelyyn. Varsinaisen asiakassivun yhteydessä modal voidaan
    kytkeä pois päältä.
  */

  product: {
    name: "Photography Premium",

    price: {
      fi: "alkaen 1 490 €",
      en: "from €1,490",
    },

    demoModal: {
      enabled: true,
      storageKey: "photography_premium_demo_intro_v3",
      delayMs: 450,
    },
  },

  languages: {
    enabled: ["fi", "en"],
    default: "fi",

    options: {
      fi: {
        code: "FI",
        name: "Suomi",
        flag: "fi",
      },

      en: {
        code: "EN",
        name: "English",
        flag: "gb",
      },
    },

    switcher: {
      variant: "flag-pill",
      showFlag: true,
      showCode: true,
    },
  },

  themes: {
    enabled: ["ivory", "noir"],
    default: "ivory",
  },

  /*
    ==========================================================
    HERO
    ==========================================================

    Jokaisella teemalla voi olla oma media.

    Tämä mahdollistaa esimerkiksi:

    Ivory:
    - valoisa video
    - tumma typografia
    - kevyt fine-art blur

    Noir:
    - tumma cinematic-video
    - vaalea typografia
    - terävämpi kuva

    Asiakaskohtainen media voidaan siis vaihtaa ilman,
    että Hero.jsx:ään tarvitsee koskea.
  */

  hero: {
    variant: "cinematic",

    media: {
      ivory: {
        type: "video",
        src: "/media/hero-ivory.mp4",
        poster: "/media/hero-ivory-poster.webp",

        /*
          Videon rajauksen painopiste.
        */
        focalPoint: "50% 0%",
        offsetY: 0,
        mobileOffsetY: 0,

        /*
          Hyvin kevyt fine-art-pehmennys.

          0 = täysin terävä.
          Noin 0.8–1.5 px toimii yleensä hienovaraisena blurina.
        */
        blur: 0.6,

        /*
          Blur voi paljastaa aivan videon reunoja.
          Pieni suurennus pitää koko heroalueen varmasti täynnä.
        */
        mediaScale: 1,
      },

      noir: {
        type: "video",
        src: "/media/hero-wedding.mp4",
        poster: "/media/hero-noir-poster.webp",

        focalPoint: "50% 50%",

        /*
          Noir jätetään tarkoituksella teräväksi.
        */
        blur: 0,
        mediaScale: 1,
      },
    },

    /*
      Overlay tulee teemakohtaisista CSS-tokeneista.
    */
    overlay: "theme",

    showScrollCue: true,
  },

  /*
    ==========================================================
    MOBILE MENU
    ==========================================================
  */

  mobileMenu: {
    variant: "editorial",

    showNumbers: true,

    showImage: false,
    image: "",
    imageAlt: "",

    showLocation: true,
    showSocials: true,
  },

  /*
    ==========================================================
    PORTFOLIO
    ==========================================================
  */

  portfolio: {
    variant: "editorial",
    lightbox: true,
  },

  /*
    ==========================================================
    CONTACT
    ==========================================================
  */

  contact: {
    /*
      ==========================================================
      BASIC CONTACT
      ==========================================================

      Asiakaskohtaiset tiedot.

      Esimerkki:
      email: "hello@example.fi",
      phone: "+358 40 123 4567",
    */

    email: "hello@photographystudio.fi",
    phone: "+358 40 123 4567",

    /*
      ==========================================================
      STUDIO
      ==========================================================

      Jos kuvaajalla ei ole studiota, kentät jätetään tyhjiksi.
      Footer ei silloin renderöi studio-osiota.

      mapsUrl voi olla esimerkiksi Google Maps -osoite.
    */

    studio: {
      name: "Photography Studio",
      street: "Kuvakatu 12",
      postalCode: "00100",
      city: "Helsinki",
      country: "Finland",
      mapsUrl: "https://www.google.com/maps/search/?api=1&query=Helsinki%2C+Finland",
    },

    /*
      ==========================================================
      COMPANY
      ==========================================================

      Yrityksen virallinen nimi ja Y-tunnus.
    */

    company: {
      legalName: "Photography Studio Oy",
      businessId: "1234567-8",
    },
  },

  /*
    ==========================================================
    SOCIALS
    ==========================================================
  */

  socials: {
    /*
      Premium-demon placeholder-linkit.
      Vaihdetaan asiakkaan omiin profiileihin käyttöönotossa.
    */
    instagram: "https://www.instagram.com/",
    facebook: "https://www.facebook.com/",
    pinterest: "https://www.pinterest.com/",
    tiktok: "https://www.tiktok.com/",
    linkedin: "https://www.linkedin.com/",
    youtube: "https://www.youtube.com/",
  },
};

export default siteConfig;
